const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    categories: [],
    categoriesPending: false,
    categoriesError: null
  },
  mutations: {
    setCategories (state, value) {
      state.categories = value
    },
    setCategoriesPending (state, value) {
      state.categoriesPending = value
    },
    setCategoriesError (state, value) {
      state.categoriesError = value
    },
  },
  actions: {
    getCategories({state, commit}){
      if (state.categories.length != 0) return
      commit('setCategoriesPending', true)
      fb.db.collection("categories").orderBy("popularity", "asc")
        .get()
        .then((querySnapshot) => {
          let categories = []
          querySnapshot.forEach((doc) => {
            categories.push({ id: doc.id, ...doc.data() })
          });
          commit('setCategories', categories)
          commit('setCategoriesPending', false)

        })
        .catch((error) => {
          commit('setCategoriesPending', false)
          commit('setCategoriesError', error)
        })
    },
    
  }
}
  